<template>
  <div class="organism-server-management_container">
    <div class="organism-server-management_card">
      <div v-if="!isEditPolicyFromTripleDot">
        <div class="server-management_card__header">
          <span class="card__header--topic">Equipment List</span>
          <b-dropdown
            v-if="checkedEquipmentList.length > 0 && hasUpdatePermission"
            no-caret
            right
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            text="Dark"
            variant="flat-dark"
            size="sm"
            class="equipment__dropdown"
          >
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon"></feather-icon>
            </template>
            <b-dropdown-item @click="clickEditTagFromTripleDot"
              ><feather-icon icon="TagIcon" class="mr-1"></feather-icon>
              <span>Edit Tag</span>
            </b-dropdown-item>
            <b-dropdown-item @click="clickEditPolicyFromTripleDot"
              ><feather-icon icon="SlidersIcon" class="mr-1"></feather-icon>
              <span>Edit Policy</span>
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item @click="clickDeleteEquipmentFromTripleDot"
              ><feather-icon icon="Trash2Icon" class="mr-1"></feather-icon>
              <span>Delete Equipment</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <molecule-server-equipment-list
          :equipmentList="equipmentList"
          :tagsList="tagsList"
          @checkedEquipmentList="updateCheckedEquipmentList"
          @selectedEquipment="updateSelectedEquipment"
        ></molecule-server-equipment-list>
      </div>

      <div v-else class="h-100">
        <div class="server-management_card__edit-policy h-100">
          <div class="edit-policy__list h-100">
            <label class="list__label--title">Selected Equipment List</label>
            <ul v-if="checkedEquipmentList.length > 0" class="list__ul--full">
              <li
                v-for="(equipment, index) in checkedEquipmentList"
                :key="index"
                class="list__li"
              >
                <label class="list__label">{{ equipment.name }}</label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="organism-server-management_monitor-events">
      <div v-if="!isEditPolicyFromTripleDot">
        <organism-server-information
          :equipmentData="selectedEquipmentDetail"
          :optionTagList="tagsList"
          :hasUpdatePermission="hasUpdatePermission"
          @updateCurrentEquipmentTagList="updateCurrentEquipmentTagList"
        ></organism-server-information>
        <organism-system-resource
          v-if="selectedEquipmentDetail"
          :cpuData="graphStatCpuData"
          :memoryData="graphStatMemoryData"
          :storageData="statStorageData"
          @datetimeParams="datetimeParams"
        ></organism-system-resource>
        <organism-server-policy
          v-if="
            selectedEquipmentDetail &&
            currentEquipmentPolicyData &&
            policyList.length
          "
          v-model="currentEquipmentPolicyData"
          :policyListFromApi="policyList"
          :equipmentData="selectedEquipmentDetail"
          :resourceData="resourceData"
          :hasUpdatePermission="hasUpdatePermission"
          @clickSave="applyPolicy"
          @getEquipmentDetail="getEquipmentDetail"
        ></organism-server-policy>
      </div>

      <div v-else class="monitor-event__edit-policy">
        <div class="edit-policy__topic">Edit Policy</div>
        <organism-server-policy
          v-if="selectedEquipmentDetail && currentEquipmentPolicyData"
          v-model="currentEquipmentPolicyData"
          :policyListFromApi="policyList"
          :equipmentData="selectedEquipmentDetail"
          :resourceData="resourceData"
          :isFromTripleDot="true"
          :checkedEquipmentList="checkedEquipmentList"
          @clickBack="isEditPolicyFromTripleDot = false"
          @getEquipmentDetail="getEquipmentDetail"
        ></organism-server-policy>
      </div>
    </div>

    <molecule-modal-dialog
      modalId="modal-delete-equipment"
      :isTextCenter="true"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete?"
      textSubtitle="You won’t be able to revert this!"
      buttonTextLeft="Delete"
      buttonColorLeft="danger"
      :isDisableButtonLeft="isDisabledButtonConfirmDelete"
      :isSlotBody="true"
      @clickButtonLeft="clickConfirmDeleteEquipment"
    >
      <template #body>
        <div class="modal-delete-equipment__list">
          <ul class="list__ul">
            <li
              v-for="(equipment, index) in checkedEquipmentList"
              :key="index"
              class="list__li"
            >
              <label class="list__label">{{ equipment.name }}</label>
            </li>
          </ul>
        </div>
        <div class="modal-delete-equipment_input">
          <atom-input
            placeholder="delete"
            title="Please type delete to confirm"
            v-model="textConfirmDeleteEquipment"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-edit-tag"
      :isTextCenter="true"
      textTitle="Edit Tag"
      textSubtitle="This will apply tags to selected equipment."
      buttonTextLeft="Apply"
      :isDisableButtonLeft="isDisabledButtonApplyEditTag"
      :isSlotBody="true"
      @clickButtonLeft="clickConfirmApplyEditTag"
    >
      <template #body>
        <div class="modal-edit-tag__dropdown">
          <div class="dropdown__label--topic">
            <span>Tags</span>
          </div>
          <atom-multi-select
            v-model="selectedTagList"
            :option="tagsList"
            :isPushTaggable="true"
            :isDisable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            placeholder="Select Tag"
          ></atom-multi-select>
        </div>
        <div class="overwrite__container mt-1">
          <atom-checkbox
            v-model="isOverWrite"
            title="Overwrite tags"
            textStyle="font-size:12px !important;"
          ></atom-checkbox>
        </div>
        <div class="modal-edit-tag__list mt-1">
          <label class="list__label--topic"
            >{{ isOverWrite ? "Overwrite" : "Apply" }} tags to equipment list
            below</label
          >
          <ul class="list__ul margin-bottom-0">
            <li
              v-for="(equipment, index) in checkedEquipmentList"
              :key="index"
              class="list__li"
            >
              <label class="list__label">{{ equipment.name }}</label>
            </li>
          </ul>
        </div>
      </template>
    </molecule-modal-dialog>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import { BDropdown, BDropdownItem, BDropdownDivider } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import OrganismPolicy from "./OrganismPolicy.vue"
import OrganismServerPolicy from "./OrganismServerPolicy.vue"
import OrganismServerInformation from "./OrganismServerInformation.vue"
import MoleculeServerEquipmentList from "@/components/molecules/serverManagementModule/server/MoleculeServerEquipmentList.vue"
import OrganismSystemResource from "./OrganismSystemResource.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import { deleteEquipmentById, getPolicyName } from "@/api/api-module"
import { PermissionUser } from "@/constants/permission-user"
import mixins from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismServerManagement",
  components: {
    OrganismPolicy,
    OrganismServerInformation,
    OrganismSystemResource,
    OrganismServerPolicy,
    MoleculeServerEquipmentList,
    MoleculeModalDialog,
    AtomInput,
    AtomMultiSelect,
    AtomCheckbox,
    BCard,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  mixins: [mixins, mixinsUser],
  props: {
    equipmentList: {
      type: Array,
      required: true,
    },
    tagsList: {
      type: Array,
      required: true,
    },
    selectedEquipmentDetail: {
      type: [Object, null],
      required: false,
      default: null,
    },
    graphStatCpuData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    graphStatMemoryData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    statStorageData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    resourceData: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emit: [
    "selectedId",
    "datetimeParams",
    "updateCurrentEquipmentTagList",
    "updateTagsFromTripleDot",
    "applyPolicy",
    "getEquipmentDetail",
  ],
  data() {
    return {
      selectedEquipment: null,
      checkedEquipmentList: [],
      isEditPolicyFromTripleDot: false,
      isOverWrite: false,
      textConfirmDeleteEquipment: "",
      modalId: "",
      selectedTagList: [],
      currentEquipmentPolicyData: {},
      currentEquipmentTagData: {},
      policyList: [],
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SMS.SERVER_MANAGEMENT_WRITE)
    },
    isDisabledButtonConfirmDelete() {
      if (this.textConfirmDeleteEquipment.toLowerCase() === "delete") {
        return false
      } else return true
    },
    isDisabledButtonApplyEditTag() {
      if (this.selectedTagList.length > 0) {
        return false
      } else return true
    },
  },
  watch: {
    selectedEquipmentDetail: {
      deep: true,
      async handler() {
        if (this.selectedEquipmentDetail) {
          await this.getPolicyNameApi()
        }
      },
    },
  },
  methods: {
    getEquipmentDetail() {
      this.$emit("getEquipmentDetail")
    },

    updateCheckedEquipmentList(checkedList) {
      this.checkedEquipmentList = checkedList
    },

    updateSelectedEquipment(selectedEquipment) {
      this.selectedEquipment = selectedEquipment

      this.$emit("selectedId", selectedEquipment.id)
    },

    applyPolicy(policy) {
      this.$emit("applyPolicy", policy)
    },

    // delete equipment
    clickDeleteEquipmentFromTripleDot() {
      this.modalId = "modal-delete-equipment"
      this.$bvModal.show(this.modalId)
    },

    async clickConfirmDeleteEquipment() {
      const targetEquipmentIdList = this.checkedEquipmentList.map(
        (equipmentId) => {
          return equipmentId.id
        }
      )
      await this.deleteEquipmentByIdApi(targetEquipmentIdList)
      this.textConfirmDeleteEquipment = ""
      this.closeModal()
      this.$router.go("/server-management/server-management")
    },

    async deleteEquipmentByIdApi(targetEquipmentIdList) {
      const response = await deleteEquipmentById(targetEquipmentIdList)
      if (response) this.toastSuccess("Equipments deleted successfully")
      else this.toastError("Equipments delete failed")
    },

    // edit tag
    clickEditTagFromTripleDot() {
      this.modalId = "modal-edit-tag"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmApplyEditTag() {
      const editTagRequest = {
        equipmentIds: this.checkedEquipmentList.map(
          (equipment) => equipment.id
        ),
        tags: this.selectedTagList,
        overwrite: this.isOverWrite,
      }
      this.$emit(
        "updateTagsFromTripleDot",
        editTagRequest,
        this.selectedEquipment?.id
      )
      this.closeModal()
    },

    // edit policy
    clickEditPolicyFromTripleDot() {
      this.isEditPolicyFromTripleDot = true
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    datetimeParams(datetimeParams) {
      this.$emit("datetimeParams", datetimeParams)
    },

    saveEquipmentDataState() {
      if (this.selectedEquipmentDetail.isCustomPolicy) {
        this.selectedEquipmentDetail.currentPolicy = {
          policyName: "Custom Policy",
          policyId: this.selectedEquipmentDetail.policy.policyId,
          policyValue: this.selectedEquipmentDetail.policy.policyValue,
        }
      } else {
        const policy = this.policyList.filter(
          (policy) =>
            policy.policyId === this.selectedEquipmentDetail.policy.policyId
        )
        this.selectedEquipmentDetail.currentPolicy = policy[0]
      }
      this.currentEquipmentPolicyData = {
        isEnable: this.selectedEquipmentDetail.isEnable,
        policyList: this.selectedEquipmentDetail.policy.policyValue,
        currentPolicy: this.selectedEquipmentDetail.currentPolicy,
      }
      this.currentEquipmentTagData = this.selectedEquipmentDetail.tag
    },

    async getPolicyNameApi() {
      await getPolicyName().then((response) => {
        this.policyList = response
        this.saveEquipmentDataState()
      })
    },

    updateCurrentEquipmentTagList(tagList) {
      this.$emit("updateCurrentEquipmentTagList", tagList)
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-server-management_container {
  display: block;
}
.organism-server-management_card {
  z-index: 1;
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  margin-bottom: 20px;
  padding-bottom: 21px;
}

.server-management_card__header {
  display: flex;
  justify-content: space-between;
  padding: 24px 15px 0 15px;
  margin-bottom: 15px;
}

.card__header--topic {
  font-weight: 700;
  font-size: 12px;
}

.server-management_card__edit-policy {
  padding: 24px 15px 0 15px;
}

.organism-server-management_monitor-events {
  background-color: #ffffff;
  width: 100%;
}

.edit-policy__list,
.modal-delete-equipment__list,
.modal-edit-tag_list {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.modal-delete-equipment__list {
  width: 224.35px;
}

.modal-edit-tag__list,
.overwrite__container {
  width: 100%;
}

.list__ul {
  margin-bottom: 15px;
  padding-left: 16px;
  max-height: 122px;
  overflow-y: auto;
}
.list__ul--full {
  margin-bottom: 15px;
  padding-left: 16px;
  height: 250px;
  overflow-y: auto;
  margin-top: 15px;
}
.list__li {
  color: #babfc7;
}
.list__label {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 6px;
}
.list__label--title {
  color: #5e5873;
  font-weight: 700;
  font-size: 12px;
}
.list__label--topic {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
}
.modal-delete-equipment_input {
  width: 100%;
}

.modal-edit-tag__dropdown {
  width: 100%;
}
.dropdown__label--topic {
  color: #6e6b7b;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 5px;
}

// edit policy
.edit-policy__topic {
  font-weight: 700;
  font-size: 30px;
  color: #7367f0;
  padding: 15px 15px 15px 15px;
}

.margin-bottom-0 {
  margin-bottom: 0 !important;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .list__ul--full {
    height: 100%;
  }

  .modal-delete-equipment_input {
    max-width: 324px;
  }

  .modal-edit-tag__dropdown,
  .modal-edit-tag__list,
  .overwrite__container {
    width: 395px;
  }

  .edit-policy__topic {
    padding: 31px 38px 24px 38px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .organism-server-management_container {
    display: flex;
  }
  .organism-server-management_card {
    width: 286px;
    height: calc(100vh - 13.1rem);
    border-radius: 6px 0px 0px 6px;
  }
  .organism-server-management_monitor-events {
    height: calc(100vh - 13.1rem);
    overflow-y: auto;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
